import { CONFIG_LOADING, UPDATE_CONFIG } from "../CONSTANTS";

export const updateRemoteConfig = (payload) => ({
  type: UPDATE_CONFIG,
  payload,
});

export const setRemoteConfigLoading = (payload) => ({
  type: CONFIG_LOADING,
  payload,
});
